module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/4_b459a88291d2504cd6a75eb02c6fd91c.jpg";